/* Defines a Popularity Route model. */
import Backbone from 'backbone';

export default Backbone.Model.extend({
    getLatitude: function() {
        return this.get('latitude');
    },

    getLongitude: function() {
        return this.get('longitude');
    },

    setLatitude: function(latitude) {
        this.set('latitude', latitude);
        return this;
    },

    setLongitude: function(longitude) {
        this.set('longitude', longitude);
        return this;
    }
});
